import React, { useRef, useEffect } from 'react';
import { useResizeObserver } from '../../tools/ResizeObserver';
import { select, scaleLinear, scaleBand, axisLeft, axisBottom, max } from 'd3';

// We will manually calculate how much margin to assign based on the length of the longest name
// const calcWidthOfName = (name) => {
// 	if (name.length < 4) return name.length * 16;
// 	if (name.length >= 4 && name.length <= 8) return name.length * 12;
// 	if (name.length > 8 && name.length < 20) return name.length * 9;
// 	if (name.length > 20) return name.length * 8.3;
// };

// const shortenName = (data) => {
// 	for (let i in data) {
// 		let name = data[i].key;
// 		if (name.length > 37) {
// 			data[i].key = name.slice(0, 37) + "...";
// 		}
// 	}
// 	return data;
// };

const BarChart = ({ data, height, colorScale = null }) => {
	const svgRef = useRef();
	const wrapperRef = useRef();
	const dimensions = useResizeObserver(wrapperRef);

	useEffect(() => {
		// Return if chart wrapper has no dimension
		if (!dimensions) return;

		// Return if no data is available
		if (data.length < 1) return;

		// shotening names that are too large from the node
		// shortenName(data);

		// Adjusting the container to fit the svg
		// let leftPadding = max(data.map((d) => calcWidthOfName(d.key)));
		let leftPadding = 90;
		select(wrapperRef.current).style('padding', `0 20px 30px ${leftPadding}px`);

		// Main drawing canvas
		const svg = select(svgRef.current).attr('height', height);

		// Define our scales
		const xScale = scaleLinear()
			.domain([0, max(data.map(d => d.value))])
			.range([0, dimensions.width]);

		const yScale = scaleBand()
			.domain(data.map(d => d.key))
			.range([0, height])
			.padding(0.1);

		// Define and draw our axis
		const xAxis = axisBottom(xScale).ticks(2);
		svg
			.select('.x-axis')
			.style('transform', `translateY(${height}px)`)
			.call(xAxis);

		const yAxis = axisLeft(yScale);
		svg.select('.y-axis').call(yAxis);

		// Draw the rect to their proper position
		svg
			.selectAll('rect')
			.data(data)
			.join('rect')
			.attr('x', d => xScale(0))
			.attr('y', d => yScale(d.key))
			.attr('width', d => xScale(d.value))
			.attr('height', yScale.bandwidth())
			.attr('fill', d => {
				if (colorScale != null) {
					if (d.key === 'other') {
						return '#DEDEDE';
					} else {
						return colorScale(d.key);
					}
				}
			})
			.on('mouseenter', d => {
				svg
					.selectAll('.tooltip')
					.data([d])
					.join('text')
					.attr('class', 'tooltip')
					.attr('x', xScale(d.value) / 2)
					.attr('y', yScale(d.key) + yScale.bandwidth() / 2)
					.text(d.value)
					.attr('text-anchor', 'middle')
					.transition()
					.attr('opacity', 1);
			})
			.on('mouseleave', () => svg.select('.tooltip').remove())
			.transition();
	}, [dimensions]);

	return (
		<div ref={wrapperRef}>
			<svg ref={svgRef}>
				<g className="x-axis"></g>
				<g className="y-axis"></g>
			</svg>
		</div>
	);
};

export default BarChart;
